import React, { createContext, useState, useContext } from 'react';

const ChallengeContext = createContext();

export const ChallengeProvider = ({ children }) => {
    const [selectedChallenge, setSelectedChallenge] = useState(null);

    return (
        <ChallengeContext.Provider value={{ selectedChallenge, setSelectedChallenge }}>
            {children}
        </ChallengeContext.Provider>
    );
};

export const useChallenge = () => useContext(ChallengeContext);